import { Component, OnInit, NgZone, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ChronologyService } from '@services/chronology.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SearchService } from '@services/search.service';
import * as _ from 'lodash';
import { TagModel } from 'ngx-chips/core/accessor';
import { filter } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
@Component({
  selector: 'app-csport',
  templateUrl: './csport.component.html',
  styleUrls: ['./csport.component.sass']
})
export class CsportComponent implements OnInit {
  sport: any = [];
  autocomplete_load = false;
  error: any = { 'name': '' };
  component = "";
  isLoading = false;
  btn_process = false;
  appCreateForm: FormGroup;
  isSubmitted = false;
  search_txt = "";
  suggestions: any = [];
  meta = "sports";
  application = "chronology";
  sports_details: any = [];
  constructor(private _searchService: SearchService, private fb: FormBuilder, private _chronology: ChronologyService, private _global: GlobalService, private router: Router) {
    this.component = this._global.COMPONENTS_SMN;
    this.appCreateForm = this.fb.group({
      sport: ['', [Validators.required]],
      description: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  ngOnInit() {

  }


  getSport(e) {
    this.sports_details = e['value'];
    this.appCreateForm.get('description').setValue(this._global.getVal(e['value'], 'description', ''));
  }
  removeSport(e) {
    this.sports_details = {};
    this.appCreateForm.get('description').setValue('');
  }
  public onAdding(tag: TagModel): Observable<TagModel> {
    tag['display'] = tag['name']
    const confirm = true;
    return of(tag).pipe(filter(() => confirm));
  }
  public requestAutocompleteItems = (text: string): Observable<any[]> => {
    let r = [];
    let p = {
      'component': this.component,
      suggestText: text,
      start: 0,
      application: 'sport',
      rows: 10
    };
    return this._searchService.suggest(p).map(
      data => {
        this.autocomplete_load = false;
        if (!_.isEmpty(this._global.getVal(data, 'response', []))) {
          let result = this._global.getVal(data, 'response', []);
          Object.entries(result).forEach(([key, value]) => {
            r.push({ value: value['doc'], name: value['doc']["name"], id: value['doc']["id"] });
          });

        }
        return r;
      });
  }
  get formField() {
    return this.appCreateForm.controls;
  }

  save() {
    this.isSubmitted = true;
    if (!this.appCreateForm.invalid) {
      let r = {};

      let metaData = {
        description: this._global.getVal(this.sports_details, 'description', ''),
        sports: this._global.getVal(this.sports_details, 'name', ''),
        category: this._global.getVal(this.sports_details, 'category', '')
      };

      this.error = { 'name': '' };
      this.btn_process = true;
      r['component'] = this.component,
        r['application'] = this.application;
      r['meta'] = this.meta;
      r['mediaType'] = 'member';
      r['mediaId'] = this._global.getSessionVal('id');
      r['description'] = this._global.getVal(this.sports_details, 'description', '');
      r['name'] = this._global.getVal(this.sports_details, 'name', '');
      r['category'] = this._global.getVal(this.sports_details, 'category', '');
      r['timeZone'] = "EST";
      r['logo'] = "";
      r['metadata'] = JSON.stringify(metaData);
      r['startTime'] = new Date().getTime();
      r['endTime'] = new Date().getTime();

      this._chronology.create(r, 'sports').subscribe(
        data => {

          let severity = 'success';
          let message = '';
          if (this._global.getVal(data, 'status', '') == 1) {
            message = this._global.getVal(data, 'message.info', '');
            this._global.showMessage({ type: severity, message: message });
            this.router.navigate(['/my/sports']);
          } else {
            this.btn_process = false;
            message = this._global.getVal(data, 'message.error', '');
            severity = 'warning';
            for (let key in data["errors"]) {
              this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
            }
            this._global.showMessage({ type: severity, message: message });
          }

        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    }
  }

}
